import React, { useContext, useEffect, useState } from "react";
import { Row, Col, Card, CardBody, Form, FormGroup, Label } from "reactstrap";
import { useForm, useController } from "react-hook-form";
import CityTransferComp from "./CityTransferComp";
import { toast } from "react-toastify";
import CustomAutoSuggest from "../../../CommonElements/CustomAutoSuggest";

import {
  PhoneNumberLabel,
  CustomerNameLabel,
  Vip,
  Corporate,
  City,
  Instructions,
  Email,
  DateTime,
  CityToAirport,
  AirportToCity,
  CityToCity,
} from "../../../Constant/index";
import { CommonModal } from "../../../AbstractElements";
import DatePicker from "react-datepicker";
import {
  postBooking,
  fetchLocation,
  editTripData,
  fetchFareEstimation,
  filterCustomers,
  findPickupType,
  getCoupons,
  applyCoupon,
  removeCoupon,
  searchCoupon,
} from "../../../Services/Booking.service";
import Select from "react-select";
import CabDetails from "./CabDetails";
import moment from "moment";
import AirportTransferComp from "./AirportTransferComp";
import {
  getCarTypes,
  getCorporateClients,
  getCorporateClientsBySeviceCityId,
  getCorporateClientsBySeviceCityIdWithoutPagination,
  getCorporatePackagesByServiceCity,
  getPackagesByServiceCity,
  getUserDetails,
  showAlert,
  getAggregatorData,
  getAggregatorDataByServiceCityIdWithoutPagable
} from "../../../Services/Shared.service";
import SharedDataContext from "../../../_helper/SharedData";
import CouponsModal from "./CouponsModal";
import OfferModal from "./OfferModal";
import CustomSelect from "../../../CommonElements/CustomSelect";

const EditBookCab = (props) => {
  const {
    register,
    handleSubmit,
    control,
    reset,
    resetField,
    getValues,
    setValue,
    watch,
    formState: { errors },
  } = useForm();

  // console.log(props, "editbookcab props");
  const cityData = props.cityData ? props.cityData : [];
  const airportData = props.airportData ? props.airportData : [];
  const [editTrip, setEditTrip] = useState(false);
  const [selectedPackage,setSelectedPackage] = useState()
  const [carTypeData, setCarTypeData] = useState([ ]);
  const [packagesData, setPackagesData] = useState([]);
  const [corporateClientData, setCorporateClientData] = useState([]);
  const [isCouponOpen, setIsCouponOpen] = useState(false);
  const [isOfferModalOpen, setIsOfferModalOpen] = useState(false);
  const [couponsData, setCouponsData] = useState([]);
  const [aggregatorList, setAggregatorList] = useState([]);
  const [aggregatorDropDownValue, setAggregatorDropDownValue] = useState("");
  const [selectedAggregator, setSelectedAggregator] = useState([]);
  const [serviceCityIdForVendor, setServiceCityIdForVendor] = useState(0);
  const [BookStatus,setBookStatus]=useState(false);

  // console.log("booking data",props?.bookingData)

  // const {
  //   register,
  //   handleSubmit,
  //   control,
  //   reset,
  //   resetField,
  //   getValues,
  //   setValue,
  //   watch,
  //   formState: { errors },
  // } = useForm();

  const getPickupType = async () => {
    if (props?.bookingData?.pickupType) return props?.bookingData?.pickupType;

    const destLat = props?.bookingData?.destLat;
    const destLng = props?.bookingData?.destLng;
    const pickUpLat = props?.bookingData?.pickUpLat;
    const pickUpLng = props?.bookingData?.pickUpLng;
    if (!destLat || !destLng || !pickUpLat || !pickUpLng) return AirportToCity;

    let obj = { destLat, destLng, pickUpLat, pickUpLng };
    return findPickupType(obj)
      .then((result) => {
        if (result.data) {
          return result.data;
        }
      })
      .catch((err) => {
        return AirportToCity;
      });
  };

  const [bookingType, setBookingType] = useState("");

  // -----------------------edit start freezing component----------------------

  useEffect(async () => {
    if (!props.Large) {
      setCouponsData([]);
      return;
    }
    setEditTrip(() => {
      return props?.editType == "Edit" ? true : false;
    });
    setBookingType(() => {
      return props?.editType ? props?.editType : "Book";
    });

    const pickupType = await getPickupType();

    setTravelType(pickupType);

    setToggleAddress(() => {
      return pickupType == CityToAirport ? true : false;
    });

    reset({
      phoneNumber: props?.bookingData?.custMobile || props?.bookingData?.custAlternateNo || "",
      customerName: props?.bookingData?.custName || "",
      instructions: props?.bookingData?.remark || "",
      email: props?.bookingData?.custEmail || "",
      custId: props?.bookingData?.custId || null,
      gender: props?.bookingData?.gender || "",
      isMoveToComplete: props?.bookingData?.isMoveToComplete
        ? props?.editType && props?.editType == "Rebook"
          ? "false"
          : props?.bookingData?.isMoveToComplete
        : "false",
      city: checkCity(),
      // customerType: checkCustomerType(),
      // destAddressDropdown: checkDestAddress(pickupType),
      // corporateClient: checkCorporateClient(),
      // sourceAddressDropdown: checkSourceAddress(pickupType),
      // airportDropdown: checkAirPort(pickupType),
      currentBookingStatusType: props?.bookingData?.currentBookingStatusType
        ? props?.editType && props?.editType == "Rebook"
          ? "New"
          : props?.bookingData?.currentBookingStatusType
        : "New",
      bookingViaType: props?.bookingData?.bookingViaType
        ? props?.editType && props?.editType == "Rebook"
          ? "CallCenter"
          : props?.bookingData?.bookingViaType
        : "CallCenter",
      createdByUserType: props?.bookingData?.createdByUserType
        ? props?.editType && props?.editType == "Rebook"
          ? "CallTaker"
          : props?.bookingData?.createdByUserType
        : "CallTaker",
      packageDropdown: null,
      destAddressDropdown: null,
      sourceAddressDropdown: null,
      airportDropdown: null,
      aggregatorDropDown: null
    });
    checkCity();


    checkDestAddress(pickupType);

    checkSourceAddress(pickupType);
    
    checkAirPort(pickupType);

    setPickupDate(() => {
      return props?.bookingData?.pickUpDateTime
        ? props?.editType && props?.editType == "Rebook"
          ? new Date().setHours(new Date().getHours() + 1)
          : new Date(props?.bookingData?.pickUpDateTime)
        : new Date().setHours(new Date().getHours() + 1);
    });

    setMinDate(() => {
      return props?.bookingData?.pickUpDateTime
        ? props?.editType && props?.editType == "Rebook"
          ? new Date()
          : new Date(props?.bookingData?.pickUpDateTime)
        : new Date();
    });

    getCorporateClients().then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        const data = result.data.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });

    const serviceId = props?.bookingData?.serviceCityId;
    if (serviceId) {
      let array = [];
      airportData.forEach((element) => {
        if (element.serviceCityId == serviceId) {
          array.push({
            value: element,
            label: element.name,
          });
        }
      });
      setAirportCityData(array);
    }
    let obj = [];
    if (props?.bookingData?.carTypeId) {
      obj.push({
        id: props?.bookingData?.carTypeId,
        count: 1,
      });
      // if (props?.bookingData?.noOfCars) {
      //   obj[props?.bookingData?.carTypeId] = props?.bookingData?.noOfCars;
      // }
    }
    setCarDetails(obj);

    setPaymentMode(() => {
      return props?.bookingData?.paymentModeType
        ? props?.bookingData?.paymentModeType
        : null;
    });
    if (props?.bookingData?.couponId) {
      console.log("props?.bookingData?.couponId", props?.bookingData?.couponId);
      setSelectedCoupon({
        couponId: props?.bookingData?.couponId,
        discountedFinalFare: props?.bookingData?.finalFare,
        code: props?.bookingData?.couponCode,
      });
    }
    checkCustomerType()
    checkCorporateClient();
    }, [props.Large]);
  

  const [toggleAddress, setToggleAddress] = useState(false);
  const [pickupDate, setPickupDate] = useState(new Date());
  const [minDate, setMinDate] = useState(new Date());
  const [airportCityData, setAirportCityData] = useState([]);

  const [dateValidation, setDateValidation] = useState({
    error: false,
    message: null,
  });

  const [carDetails, setCarDetails] = useState([]);

  const [estimatedData, setEstimatedData] = useState([]);

  const [paymentMode, setPaymentMode] = useState(null);
  const [travelType, setTravelType] = useState(AirportToCity);

  const [selectedCoupon, setSelectedCoupon] = useState({});
  console.log("selected coupon", selectedCoupon);

  const handleSourceSelectChange = (data) => {
    sourceAddressField.onChange(data.value);
  };
  console.log(props.editType,"props.bookingData")

  const handlePhoneNumberSelect = (data) => {
    const value = data.value;
    console.log(value, "value");
    setValue("phoneNumber", value?.mobile);
    setValue("customerName", value?.fullName);
    setValue("gender", value?.gender);
    setValue("email", value?.email);
    setValue("custId", value?.id);
    if (value?.isVip) {
      setValue("customerType", "Vip");
    } else if (value?.isCorporateAccount) {
      setValue("customerType", "Corporate");
      if (value?.corporateClientId) {
        const corporateClientObj = corporateClientData.find(
          (element) => element.value.id == value?.corporateClientId
        );
        if (corporateClientObj && Object.keys(corporateClientObj).length > 0) {
          return corporateClientField.onChange(corporateClientObj.value);
        }
      }
    }
    if (value?.city) {
      console.log(cityData, "cityData");
      const cityObj = cityData.find(
        (element) =>
          element.value.name.toLowerCase() == value?.city.toLowerCase()
      );
      console.log(cityObj, "cityObj");
      if (cityObj && Object.keys(cityObj).length > 0) {
        console.log("callleddd");
        return cityField.onChange(cityObj.value);
      }
    }
  //  }
  };


  const checkCustomerType = () => {
    if (props?.bookingData?.isVip) {
      setValue("customerType", "Vip");
    } else if (props?.bookingData?.isCompanyBooking) {
      setValue("customerType", "Corporate");
    } else {
      setValue("customerType", "Standard");
    }
  };

  const checkCity = () => {
    let city = undefined;
    if (props?.bookingData?.serviceCityId && cityData.length > 0) {
      city = cityData.find(
        (element) => element.value.id == props?.bookingData.serviceCityId
      );
      if (city && Object.keys(city).length > 0) {
        return cityField.onChange(city.value);
      }
    }
    return cityField.onChange(city);
  };
  const checkDestAddress = (pickupType) => {
    let destAddress = undefined;
    if (pickupType == AirportToCity || pickupType == CityToCity) {
      if (props?.bookingData?.destAddress) {
        destAddress = {
          address: props?.bookingData?.destAddress,
          lat: props?.bookingData?.destLat,
          lng: props?.bookingData?.destLng,
        };
      }
    } else {
      if (props?.bookingData?.pickUpAddress) {
        destAddress = {
          address: props?.bookingData.pickUpAddress,
          lat: props?.bookingData?.pickUpLat,
          lng: props?.bookingData?.pickUpLng,
        };
      }
    }
    console.log(destAddress, "destAddressdestAddressdestAddressdbhfb");
    return destAddressField.onChange(destAddress);
  };

  const updateAirPortCityState = (serviceId) => {
    let array = [];
    if (serviceId) {
      airportData.forEach((element) => {
        if (element.serviceCityId == serviceId) {
          array.push({
            value: element,
            label: element.name,
          });
        }
      });
    }
    setAirportCityData(array);
  };

  const checkSourceAddress = (pickupType) => {
    let sourceAddress = null;
    if (pickupType == AirportToCity || pickupType == CityToCity) {
      if (props?.bookingData?.pickUpAddress) {
        sourceAddress = {
          address: props?.bookingData.pickUpAddress,
          lat: props?.bookingData?.pickUpLat,
          lng: props?.bookingData?.pickUpLng,
        };
      }
    } else {
      if (props?.bookingData?.destAddress) {
        sourceAddress = {
          address: props?.bookingData?.destAddress,
          lat: props?.bookingData?.destLat,
          lng: props?.bookingData?.destLng,
        };
      }
    }
    return sourceAddressField.onChange(sourceAddress);
  };

  const checkAirPort = (pickupType) => {
    let airport = null;
    if (pickupType == AirportToCity || pickupType == CityToCity) {
      if (props?.bookingData?.pickUpAddress) {
        airport = {
          name: props?.bookingData.pickUpAddress,
          lat: props?.bookingData?.pickUpLat,
          lng: props?.bookingData?.pickUpLng,
        };
      }
    } else {
      console.log(pickupType, "pickupType");
      if (props?.bookingData?.destAddress) {
        airport = {
          name: props?.bookingData?.destAddress,
          lat: props?.bookingData?.destLat,
          lng: props?.bookingData?.destLng,
        };
      }
    }

    return airportField.onChange(airport);
  };

  const checkCorporateClient = () => {
    let corporateClient = undefined;
    if (
      props?.bookingData?.isCompanyBooking &&
      props?.bookingData?.corporateClientId
    ) {
      return corporateClientField.onChange({
        id: props?.bookingData?.corporateClientId,
        companyName: props?.bookingData?.companyName
      });
    } else {
      return corporateClientField.onChange(corporateClient);
    }
  };

  const cityField = useController({
    name: "city",
    control,
    rules: {
      required: {
        value: true,
        message: "City is Required",
      },
    },
  }).field;

  const destAddressField = useController({
    name: "destAddressDropdown",
    control,
  }).field;

  const sourceAddressField = useController({
    name: "sourceAddressDropdown",
    control,
  }).field;

  const corporateClientField = useController({
    name: "corporateClient",
    control,
  }).field;

  const airportField = useController({
    name: "airportDropdown",
    control,
  }).field;

  const packageField = useController({
    name: "packageDropdown",
    control,
  }).field;

  const aggregatorField = useController({
    name: "aggregatorDropDown",
    control,
  }).field;


  const customerTypeWatch = watch("customerType");

  const {testPack} = watch();



  const myTimeout = 0;
  const getAddressData = async (inputValue) => {
    if (inputValue) {
      let obj = {
        key: inputValue,
        isAgentApp: true,
        geoApi: false,
        address: null,
        requestSource: "TMS",
      };
      return fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element?.address ? element.address : element,
            };
          });
          return data;
        }
        return [];
      });
    }
  };

  const onChangePickUP = (date) => {
    setPickupDate(date);
    if (new Date(date) < new Date()) {
      setDateValidation({
        error: true,
        message: "Pickup Datetime cannot be less than Current Time",
      });
    } else {
      setDateValidation({
        error: false,
        message: null,
      });
    }
  };

  const searchCustomers = async (inputValue) => {
    if (inputValue) {
      return filterCustomers(inputValue).then((result) => {
        if (result.data.length > 0) {
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element.mobile,
            };
          });
          return data;
        }
        return [];
      });
    }
  };

  const clearFareData = () => {
    packageField.onChange("")
    setEstimatedData([]);
    setSelectedCoupon({});
    setCarDetails([]);
    setPaymentMode(null)
  };
  useEffect(()=>{
    clearFareData();
    if(customerTypeWatch != "Corporate"){
      setValue("corporateClient","")
    }
  },[customerTypeWatch])

  useEffect(() => {
    if (serviceCityIdForVendor > 0) {
      getAggregatorDataByServiceCityIdWithoutPagable(serviceCityIdForVendor).then((result) => {

        console.log(result, "AGGREGATOR LIST VALUE BASED ON SERVICE CITY ID")
        if (result.status === 200 && result.data.length > 0) {
          const data = [
            { value: null, label: "None" },
            ...result.data.filter((element) => element.isDeleted === false).map((element) => ({
              value: element,
              label: element.companyName,
            })),
          ];
          setAggregatorList(data);
        }
        else
        {
          const data = [
            { value: null, label: "None" }
          ]
          setAggregatorList(data);
        }
      });
    } else {
      getAggregatorData().then((result) => {
        
        if (result.status === 200 && result.data.length > 0) {
          const data = [
            { value: null, label: "None" },
            ...result.data.filter((element) => element.isDeleted === false).map((element) => ({
              value: element,
              label: element.companyName,
            })),
          ];
          setAggregatorList(data); 
        }
      });
    }
  }, [serviceCityIdForVendor]); 


  useEffect(() => {
    setSelectedCoupon({});
    const serviceCityId = cityField.value?.id;
    updateAirPortCityState(serviceCityId);
    if (!serviceCityId) {
      setCarTypeData([]);
      return;
    }
    let obj = {
      serviceCityId,
      // travelType: travelType == AirportToCity && !toggleAddress ? "A2C" : "C2A",
    };
    getCarTypes(obj)
      .then((result) => {
        if (!editTrip) {
          clearFareData();
        }
        setCarTypeData(result.data);
      })
      .catch((err) => {
        showAlert("error", "Unable to fetch Car details for selected City");
      });
    setValue("customerType", "Standard")
    corporateClientField.onChange("")
    packageField.onChange("")
    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });

    const rideType = travelType == AirportToCity ? toggleAddress ? "C2A" : "A2C" : "C2C"

    getCoupons({ serviceCityId, rideType }).then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setCouponsData(result.data);
        setSelectedCoupon({})
      }
    }).catch((err) => {
      setSelectedCoupon({})
      setCouponsData([])
    });

    setServiceCityIdForVendor(cityField.value.id ? cityField.value.id : 0);
  }, [cityField.value]);

  // ---------------------------------toggle transfer type------------------------------------
  useEffect(() => {
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) {
      return;
    }
    setValue("customerType", "Standard")
    corporateClientField.onChange("")
    packageField.onChange("")
    let obj = {
      serviceCityId,
      // travelType: travelType == AirportToCity && !toggleAddress ? "A2C" : "C2A",
    };
    getCorporateClientsBySeviceCityIdWithoutPagination(obj).then((result) => {
      if (result.status == 200) {
        const data = result.data.list.map((element) => {
          return {
            value: element,
            label: element.companyName,
          };
        });
        setCorporateClientData(data);
      }
    });
    const rideType = travelType == AirportToCity ? toggleAddress ? "C2A" : "A2C" : "C2C"

    getCoupons({ serviceCityId, rideType }).then((result) => {
      if (result.status == 200 && result.data.length > 0) {
        setSelectedCoupon({})
        setCouponsData(result.data);
      }
    }).catch((err) => {
      setSelectedCoupon({})
      setCouponsData([])
    });
  }, [travelType, toggleAddress]);

  // -----------------------------PACKAGE SELECTOR USEEFFECT-------------------------
  useEffect(() => {
    const serviceCityId = cityField.value?.id;
    if (!serviceCityId) return;
    const corporateClientId = corporateClientField.value?.id || null;

    console.log(corporateClientId, "corporateClientId");

    let obj = {
      serviceCityId,
      corporateClientId,
    };

    if (corporateClientId && customerTypeWatch == "Corporate") {
      getCorporatePackagesByServiceCity(obj)
        .then((result) => {
          let selectedPackage = undefined;
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element.name,
            };
          });
          data.unshift({
            value: {
              name: "Based on Kilometers",
              id: null,
            },
            label: "Based on Kilometers",
          });
          setPackagesData(data);
          console.log(
            props?.bookingData?.packageId,
            "props?.bookingData?.packageId"
          );
          if (props?.bookingData?.packageId) {
            selectedPackage = result.data.find(
              (element) => element.id == props?.bookingData?.packageId
            );
            setSelectedPackage(selectedPackage);
          }
          console.log(selectedPackage, "selectedPackage");

          packageField.onChange(selectedPackage);
          // setValue("testPack",selectedPackage)
        })
        .catch((err) => {
          showAlert("error", "Unable to fetch packages for selected City");
        });
    } else {
      getPackagesByServiceCity(obj)
        .then((result) => {
          let selectedPackage = undefined;
          let data = result.data.map((element) => {
            return {
              value: element,
              label: element.name,
            };
          });
          data.unshift({
            value: {
              name: "Based on Kilometers",
              id: null,
            },
            label: "Based on Kilometers",
          });
          setPackagesData(data);
          console.log(
            props?.bookingData?.packageId,
            "props?.bookingData?.packageId"
          );
          if (props?.bookingData?.packageId) {
            selectedPackage = result.data.find(
              (element) => element.id == props?.bookingData?.packageId
            );
            setSelectedPackage(selectedPackage)
          }
          console.log(selectedPackage, "selectedPackage");

          packageField.onChange(selectedPackage);
          // setValue("testPack",selectedPackage)
        })
        .catch((err) => {
          showAlert("error", "Unable to fetch packages for selected City");
        });
    }
  }, [cityField.value, corporateClientField.value, customerTypeWatch]);
  console.log("cityField.value, corporateClientField.value, customerTypeWatch",cityField.value, corporateClientField.value, customerTypeWatch)

  useEffect(()=>{
    if(selectedPackage){
      console.log("selectedPackageState",selectedPackage)
      packageField.onChange(selectedPackage)
    }
  },[selectedPackage])
  
  const handleCitySelectChange = (data) => {
    cityField.onChange(data.value);
    setAggregatorDropDownValue("");
    setSelectedAggregator(null)
  };

  useEffect(()=>{
    console.log(">>> selectedAggregator is ", selectedAggregator);
  }, selectedAggregator)
  // ----------------------------responsible for selection

  useEffect(() => {
    if (
      packagesData.length > 0 &&
      props?.bookingData?.packageId !== null &&
      props?.bookingData?.packageId !== undefined
    ) {
      let selectedPackData = packagesData.find(
        (element) => element.value.id == props?.bookingData?.packageId
      );

      packageField.onChange(selectedPackData);
    }
  }, [
    packagesData,
    cityField.value,
    corporateClientField.value,
    customerTypeWatch,
  ]);

  const fetchAddressData = () => {
    var now = moment(new Date()); // current datetime
    var end = moment(pickupDate);
    const duration = moment.duration(end.diff(now));
    const timeDiff = duration.asMinutes();
    const sourceAddress =
      travelType == CityToCity ? sourceAddressField.value : airportField.value;
    const destAddress = destAddressField.value;
    if (travelType == AirportToCity || travelType == CityToAirport) {
      let rideType = "AirportPickup";
      let pickupObj = {
        address: sourceAddress?.name,
        lat: Number(sourceAddress?.lat),
        lng: Number(sourceAddress?.lng),
      };
      let destObj = {
        address: destAddress?.address,
        lat: Number(destAddress?.lat),
        lng: Number(destAddress?.lng),
      };
      if (toggleAddress) {
        // rideType = timeDiff >= 45 ? "RideLater" : "RideNow";
        rideType = "RideLater";
        pickupObj = {
          address: destAddress?.address,
          lat: Number(destAddress?.lat),
          lng: Number(destAddress?.lng),
        };
        destObj = {
          address: sourceAddress?.name,
          lat: Number(sourceAddress?.lat),
          lng: Number(sourceAddress?.lng),
        };
      }
      return { pickupObj, destObj, rideType };
    } else {
      // let rideType = timeDiff >= 45 ? "RideLater" : "RideNow";
      let rideType = "KurbPickup";
      let pickupObj = {
        address: sourceAddress?.address,
        lat: Number(sourceAddress?.lat),
        lng: Number(sourceAddress?.lng),
      };
      let destObj = {
        address: destAddress?.address,
        lat: Number(destAddress?.lat),
        lng: Number(destAddress?.lng),
      };
      return { pickupObj, destObj, rideType };
    }
  };

  const handleDestSelectChange = (data) => {
    destAddressField.onChange(data.value);
  };

  const handleCorporateSelectChange = (data) => {
    corporateClientField.onChange(data.value);
  };

  const handleAirportSelectChange = (data) => {
    airportField.onChange(data.value);
  };

  const handlePackageSelectChange = (data) => {
    setCarDetails([]);
    packageField.onChange(data.value);
  };

  const handleCustomAirportSelectChange = (data) => {
    const value = data.value;
    const obj = {
      name: value.address,
      lat: value.lat,
      lng: value.lng,
    };
    airportField.onChange(obj);
  };

  const calculateEstimation = (pickupObj, destObj) => {
    if (!pickupObj.address || !destObj.address) return;
    let body = {
      pickupLat: pickupObj?.lat,
      pickupLng: pickupObj?.lng,
      destLat: destObj?.lat,
      destLng: destObj?.lng,
      isPackage: packageField.value?.id ? true : false,
      packageId: packageField.value?.id,
      serviceCityId: cityField.value?.id ? cityField.value?.id : null,
      bookingSourceType: "TMS",
      customerMobile: getValues("phoneNumber")
    };
 
      fetchFareEstimation(body)
        .then((result) => {
          console.log("pickuop----", result);
          if (result.data) {
            const fareData = [];
            let hasOffer = false;
            result.data.forEach((element) => {
              const fare = element.finalFare;
              const distance = packageField.value?.id
                ? element.estimatedDistanceInKmOnly
                : element.estimatedMinKM;
              if (element.discountedEstimateFare != null && element.discountedEstimateFare !== 0) {
                hasOffer = true;
              }
              fareData.push({
                ...element,
                carTypeId: element.carTypeId,
                estimatedMinFare: fare,
                baseFare:element.estimatedMinFare,
                active: fare || fare == 0 ? true : false,
                estimatedMinKM: distance,
              });
            });
            console.log(fareData, "fareData");
            setEstimatedData(fareData);
            if (hasOffer) {
              setIsOfferModalOpen(true);
            }
          } else {
            clearFareData();
          }
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response.data.message
              ? err.response.data.message
              : "Cannot Calculate fare for given location"
          );
          clearFareData();
        });
    
  };

  const handleAggregatorSelectChange = (data) => {
    console.log(">>>>> ID value of Aggregator is ", data);
    aggregatorField.onChange(data.value)
    setAggregatorDropDownValue(aggregatorList?.id)
  }

  useEffect(() => {
    if (aggregatorField.value?.id && aggregatorDropDownValue !== "") {
      setSelectedAggregator(aggregatorField.value.id);
    } else {
      setSelectedAggregator(null);
    }
    console.log(">>>>>>>>>> selected aggregator value is ::: ", selectedAggregator)
  }, [aggregatorDropDownValue]);

  useEffect(() => {
    if (airportField.value?.name) {
      console.log(airportField.value?.name, "airportField.value?.name");
      setValue("airport", airportField.value?.name);
    } else {
      setValue("airport", "");
    }
  }, [airportField.value]);

  // -----------------to debug mis-223
  useEffect(() => {
    if (sourceAddressField.value?.address) {
      setValue("sourceAddress", sourceAddressField.value?.address);
    } else if (sourceAddressField.value) {
      let obj = {
        key: null,
        isAgentApp: true,
        geoApi: true,
        address: sourceAddressField.value,
        requestSource: "TMS"
      }
      fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          sourceAddressField.onChange(result.data[0])
        }
      });
    } else {
      setValue("sourceAddress", "");
    }
  }, [sourceAddressField.value]);

  useEffect(() => {
    if (destAddressField.value?.address) {
      setValue("destAddress", destAddressField.value?.address);
    } else if (destAddressField.value) {
      let obj = {
        key: null,
        isAgentApp: true,
        geoApi: true,
        address: destAddressField.value,
        requestSource: "TMS"
      }
      fetchLocation(obj).then((result) => {
        if (result.data.length > 0) {
          destAddressField.onChange(result.data[0])
        }
      });
    } else {
      setValue("destAddress", "");
    }
    console.log(
      destAddressField.value?.address,
      "destAddressdestAddressdestAddressdestAddress"
    );
  }, [destAddressField.value]);

  //----------------- extemation calculation----------------------------------------------
  useEffect(() => {
    console.log(
      airportField.value,
      destAddressField.value,
      sourceAddressField.value,
      "airportField.value, destAddressField.value,sourceAddressField.value"
    );
    const { pickupObj, destObj } = fetchAddressData();
    console.log(pickupObj, destObj, "pickupObj, destObj");
    if (pickupObj.address && destObj.address) {
      calculateEstimation(pickupObj, destObj);
    } else {
      clearFareData();
    }
  }, [
    airportField.value,
    destAddressField.value,
    sourceAddressField.value,
    toggleAddress,
    travelType,
    packageField.value,
  ]);

  // --------------------------------form object helper------------------------------------------------
  const generateRequest = (formValues, selectedCar) => {
    const { pickupObj, destObj, rideType } = fetchAddressData();
    // const numberOfCars = carDetails[selectedCar];
    const numberOfCars = 1;
    const carObj = carTypeData.find((element) => element.id == selectedCar);
    const pickupTime = moment(new Date(pickupDate)).format("hh:mm");
    const pickUpDateFormat = moment(new Date(pickupDate)).format("MM/DD/YYYY");
    const userDetails = getUserDetails();
    const fareObj = estimatedData.find(
      (element) => element.carTypeId == selectedCar
    );

    const obj = {
      userId: userDetails.userId,
      createdById: userDetails.userId,
      packageId: packageField?.value?.id ? packageField.value.id : null,
      packageName: packageField?.value?.id ? packageField.value.name : null,
      currentBookingStatusType: formValues.currentBookingStatusType,
      bookingViaType: travelType == AirportToCity ? toggleAddress ? "CallCenter" : "AirportBooking" : "CallCenter",
      custName: formValues.customerName,
      custMobile: formValues.phoneNumber,
      pickUpDate: pickUpDateFormat,
      pickUpTime: pickupTime,
      pickUpDateTime: new Date(pickupDate),
      serviceCityId: formValues.city.id,
      createdByUserType: formValues.createdByUserType,
      paymentModeType: paymentMode,
      pickUpAddress: pickupObj.address,
      bookingTotalFare: fareObj.estimatedMinFare,
      bookingTotalDistance: fareObj.estimatedMinKM,
      overviewPolyline: fareObj.overviewPolyline,
      estimatedKm: fareObj.estimatedKm,
      pickUpLat: pickupObj.lat,
      pickUpLng: pickupObj.lng,
      pickUpCenter: [null, null],
      destAddress: destObj.address,
      destLat: destObj.lat,
      destLng: destObj.lng,
      destCenter: [null, null],
      custEmail: formValues.email,
      gender: formValues.gender,
      custId: formValues.custId,
      rideType: rideType,
      isMoveToComplete: formValues.isMoveToComplete,
      noOfCars: carDetails[0]["count"],
      carTypeId: Number(selectedCar),
      carType: carObj.name,
      remark: formValues.instructions,
      isCompanyBooking:
        formValues.customerType == "Corporate" ? "true" : "false",
      corporateClientId:
        formValues.customerType == "Corporate"
          ? formValues.corporateClient?.id
          : null,
      companyName: formValues.corporateClient?.companyName || null,
      isVip: formValues.customerType == "Vip" ? "true" : "false",
      isCouponApplied: selectedCoupon?.couponId ? true : false,
      couponId: selectedCoupon?.couponId ? selectedCoupon?.couponId : null,
      estimatedFare: fareObj.estimatedMinFare,
      discountedEstimateFare: selectedCoupon?.couponId
        ? selectedCoupon?.finalFare
        : fareObj?.discountedEstimateFare || null,
      aggregatorId : selectedAggregator ? selectedAggregator : null,
    };
    return obj;
  };
  // --------------------------------booking submit and updation-----------------------------------
  const onBookingSubmit = async (formValues) => {
    if (dateValidation.error) return;
    const selectedCar = carDetails.length > 0 ? carDetails[0].id : 0;
    if (selectedCar && selectedCar != 0 && paymentMode) {
      let obj = generateRequest(formValues, selectedCar);
      if (editTrip) {
        obj["id"] = props?.bookingData?.id;
        obj["megaCabsBookingNo"] = props?.bookingData?.megaCabsBookingNo;
        obj["otp"] = props?.bookingData?.otp;
        obj["userId"] = props?.bookingData?.userId ? props?.bookingData.userId : props?.bookingData.createdById;
        obj["createdById"] = props?.bookingData?.userId ? props?.bookingData.userId : props?.bookingData.createdById;
        obj["bookingSourceType"] = props?.bookingData?.bookingSourceType ? props?.bookingData.bookingSourceType : null;
        if (!obj["isCouponApplied"])
          obj["couponId"] = props?.bookingData?.couponId;
        console.log(obj, "obj");
        props.setShowApiLoader(true);
        setBookStatus(true);
        editTripData(obj)
          .then(async (result) => {
            console.log(result, "result");
            props.setShowApiLoader(false);
            showAlert("success", "Booking Updated Successfully");
            await props?.onSubmitData?.fetchBookingData()
            props.LargeModaltoggle();
          })
          .catch((err) => {
            props.setShowApiLoader(false);
            showAlert("error", "Something went wrong");
            setBookStatus(false);
          });
      } else {
        console.log(obj, "obj");
        props.setShowApiLoader(true);
        postBooking(obj)
          .then(async (result) => {
            console.log(result, "result");
            props.setShowApiLoader(false);
            showAlert("success", "Booking Created Successfully");
            await props?.onSubmitData?.fetchBookingData()
            props.LargeModaltoggle();
          })
          .catch((err) => {
            console.log(err.data, "dfjdfjdf");
            console.log(err, "error");
            console.log("error response", err.response);
            props.setShowApiLoader(false);
            showAlert(
              "error",
              err.response.data.message
                ? err.response.data.message
                : "Something went wrong"
            );
          });
      }
    } else {
      toast.error("Select Car and Payment Mode", {
        position: "bottom-center",
        autoClose: 3000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnFocusLoss: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }
  };

  const onError = (errorInfo) => {
    console.log(errorInfo, "erroringo");
  };
  // ---------------------------------------coupoun------------------------------------------------------------------
  useEffect(() => {
    const selectedCarId = carDetails.length > 0 ? carDetails[0].id : 0;
    if (selectedCarId && selectedCarId != 0) {
      const fareObj = estimatedData.find(
        (element) => element.carTypeId == selectedCarId
      );
      if (fareObj?.baseFare || fareObj?.baseFare == 0 ) {
        const rideType = travelType == AirportToCity ? toggleAddress ? "C2A" : "A2C" : "C2C"
        const obj = {
          code: selectedCoupon.code,
          estimatedFare: fareObj.baseFare,
          couponId: selectedCoupon.couponId,
          serviceCityId: cityField.value?.id ? cityField.value?.id : null,
          rideType,
          convenienceCharge: fareObj.convenienceCharge,
          bookingFees: fareObj.bookingFees,
          isPackage: packageField.value?.id ? true : false,
          packageId: packageField.value?.id ? packageField.value.id : null,
          rateId: fareObj.rateId
        };
        applyCoupon(obj)
          .then((resp) => {
            setSelectedCoupon(resp.data);
          })
          .catch((err) => {
            console.log("error", err);
          });
      }
    }
  }, [estimatedData]);

  const couponApply = (code, couponId, selectedCarId) => {
    const fareObj = estimatedData.find(
      (element) => element.carTypeId == selectedCarId
    );
    if (fareObj?.baseFare) {
      const rideType = travelType == AirportToCity ? toggleAddress ? "C2A" : "A2C" : "C2C"
      const obj = {
        code: code,
        estimatedFare: fareObj.baseFare,
        couponId: couponId,
        serviceCityId: cityField.value?.id ? cityField.value?.id : null,
        rideType,
        convenienceCharge: fareObj.convenienceCharge,
        bookingFees: fareObj.bookingFees,
        isPackage: packageField.value?.id ? true : false,
        packageId: packageField.value?.id ? packageField.value.id : null,
        rateId: fareObj.rateId
      };
      applyCoupon(obj)
        .then((resp) => {
          setSelectedCoupon(resp.data);
          setIsCouponOpen(false);
          showAlert("success", "Coupon applied Successfully");
        })
        .catch((err) => {
          showAlert(
            "error",
            err.response.data.message
              ? err.response.data.message
              : "Something went wrong"
          );
        });
    }
  };

  const couponSearch = (couponCode) => {
    const rideType = travelType == AirportToCity ? toggleAddress ? "C2A" : "A2C" : "C2C"
    const obj = {
      couponCode,
      serviceCityId: cityField.value?.id ? cityField.value?.id : null,
      rideType
    };
    searchCoupon(obj)
      .then((resp) => {
        couponApply(resp.data.code, resp.data.id, carDetails[0].id)
      })
      .catch((err) => {
        showAlert(
          "error",
          err.response.data.message
            ? err.response.data.message
            : "Something went wrong"
        );
      });
  };

  // const couponRemove = () => {
  //   const obj = {
  //     custId: props?.bookingData?.custId,
  //     megaCabsBookingNo: props?.bookingData?.megaCabsBookingNo,
  //     couponId: props?.bookingData?.couponId,
  //   };
  //   removeCoupon(obj)
  //     .then((resp) => {
  //       setSelectedCoupon({});
  //       showAlert("success", "Coupon removed Successfully");
  //     })
  //     .catch((err) => {
  //       showAlert(
  //         "error",
  //         err.response.data.message
  //           ? err.response.data.message
  //           : "Something went wrong"
  //       );
  //     });
  // };

  console.log("car details", carDetails);
  console.log("rideType", toggleAddress, travelType)
  console.log("values", getValues())
  console.log("corporate field", packageField.value)

  // --------------------------------------component start here-----------------------------------------
  const hasDiscountedFare = estimatedData?.some((item) => item?.discountedEstimateFare > 0);

  return (
    <CommonModal
      isOpen={props.Large}
      title={props.title}
      toggler={props.LargeModaltoggle}
      size="xl"
    >
      <Form onSubmit={handleSubmit(onBookingSubmit, onError)}>
        <Row className="book-a-cab">
          <Row className="book-a-cab-form">
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {PhoneNumberLabel}
              </Label>
              <Col lg="8">
                <CustomAutoSuggest
                  id={"Phone Number"}
                  registerName={"phoneNumber"}
                  handleSelectChange={handlePhoneNumberSelect}
                  options={searchCustomers}
                  placeholder={"Enter Phone Number"}
                  register={register}
                  inputType={"number"}
                  inputProps={{
                    required: {
                      value: true,
                      message: "Phone number is required",
                    },
                    minLength: {
                      value: 10,
                      message: "Phone number cannot be less than 10",
                    },
                    maxLength: {
                      value: 10,
                      message: "Phone number cannot be more than 10",
                    },
                    min: {
                      value: 0,
                      message: "Invalid Phone Number",
                    },
                  }}
                  dependentRegisterName={""}
                />
                <span style={{ color: "red" }}>
                  {errors?.phoneNumber?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {CustomerNameLabel}
              </Label>
              <Col lg="8">
                <input
                  className="form-control"
                  {...register("customerName", {
                    required: {
                      value: true,
                      message: "Customer Name is required",
                    },
                    pattern: {
                      value: /^[^\s].+[^\s]$/,
                      message: "Invalid Customer name",
                    },
                  })}
                  type="text"
                />
                <span style={{ color: "red" }}>
                  {errors?.customerName?.message}
                </span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{City}</Label>
              <Col lg="8">
                <div className="city-select">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={false}
                    value={{
                      label: cityField?.value?.name,
                      value: cityField?.value,
                    }}
                    isDisabled={bookingType == "Edit" ? true : false}
                    onChange={handleCitySelectChange}
                    placeholder="Select City"
                    options={cityData}
                  />
                </div>
                <span style={{ color: "red" }}>{errors?.city?.message}</span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{DateTime}</Label>
              <Col lg="8">
                <DatePicker
                  className="form-control"
                  selected={pickupDate}
                  onChange={(date) => onChangePickUP(date)}
                  timeInputLabel="Time:"
                  minDate={new Date(minDate)}
                  // maxDate={new Date().setDate(new Date().getDate()+5)}
                  dateFormat="dd/MM/yyyy HH:mm"
                  showTimeInput
                  shouldCloseOnSelect={false}
                  showYearDropdown
                  showMonthDropdown
                  scrollableYearDropdown
                />
                {dateValidation.error ? (
                  <span style={{ color: "red" }}>{dateValidation.message}</span>
                ) : (
                  ""
                )}
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{Email}</Label>
              <Col lg="8">
                <input
                  className="form-control"
                  {...register("email", {
                    required: {
                      value: false,
                    },
                    pattern: {
                      value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                      message: "Please enter a valid email !",
                    },
                  })}
                  type="text"
                />
                <span style={{ color: "red" }}>{errors?.email?.message}</span>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{"Gender"}</Label>
              <Col className="col-lg-8">
                <div className="m-checkbox-inline mb-0 custom-radio-ml">
                  <div className="radio radio-primary">
                    <input
                      id="GenderMale"
                      type="radio"
                      {...register("gender", {
                        required: {
                          value: true,
                          message: "Gender is required",
                        },
                      })}
                      value="M"
                    />
                    <Label className="mb-0" htmlFor="GenderMale">
                      {"Male"}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="GenderFemale"
                      type="radio"
                      value="F"
                      {...register("gender", {
                        required: {
                          value: true,
                          message: "Gender is required",
                        },
                      })}
                    />
                    <Label className="mb-0" htmlFor="GenderFemale">
                      {"Female"}
                    </Label>
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.gender?.message}
                  </span>
                </div>
              </Col>
            </FormGroup>
            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {"Customer Type"}
              </Label>
              <Col className="col-lg-8">
                <div className="m-checkbox-inline mb-0 custom-radio-ml">
                  <div className="radio radio-primary">
                    <input
                      id="Vipuser"
                      type="radio"
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                      value="Standard"
                    />
                    <Label className="mb-0" htmlFor="Vipuser">
                      Standard
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="Standarduser"
                      type="radio"
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                      value="Vip"
                    />
                    <Label className="mb-0" htmlFor="Standarduser">
                      {Vip}
                    </Label>
                  </div>
                  <div className="radio radio-primary">
                    <input
                      id="CorporateUser"
                      type="radio"
                      value="Corporate"
                      disabled={cityField?.value ? false : true}
                      {...register("customerType", {
                        required: {
                          value: true,
                          message: "Customer Type is required",
                        },
                      })}
                    />
                    <Label className="mb-0" htmlFor="CorporateUser">
                      {Corporate}
                    </Label>
                  </div>
                  <span style={{ color: "red" }}>
                    {errors?.customerType?.message}
                  </span>
                </div>
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12 coorporate-input">
              {customerTypeWatch == "Corporate" ? (
                <Col lg="8">
                  <CustomSelect
                    className="service-select"
                    classNamePrefix="select"
                    isClearable={false}
                    isSearchable={true}
                    value={corporateClientData.find((element) => {
                      return (
                        element?.value?.id === corporateClientField?.value?.id
                      );
                    })}
                    onChange={handleCorporateSelectChange}
                    placeholder="Select Corporate Client"
                    options={corporateClientData}
                  />
                </Col>
              ) : (
                ""
              )}
            </FormGroup>

            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">
                {'Aggregator'}
              </Label>
              <Col className="col-lg-8">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={aggregatorDropDownValue}
                  onChange={handleAggregatorSelectChange}
                  placeholder="Select Aggregator"
                  options={aggregatorList}
                  isDisabled = {(serviceCityIdForVendor === 0 || cityField.value === undefined) ? true : false }
                />
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12">
              <Label className="col-lg-4 col-form-label">{Instructions}</Label>
              <Col lg="8">
                <textarea
                  className="form-control"
                  {...register("instructions")}
                  type="text"
                />
              </Col>
            </FormGroup>

            <FormGroup className="row col-lg-12"></FormGroup>
          </Row>
          <Row className="add-address">
            <Card className="travel-details">
              <div
                className={`travel-mode ${travelType == AirportToCity || travelType == CityToAirport
                  ? "active"
                  : ""
                  }`}
                onClick={() => setTravelType(AirportToCity)}
              >
                Airport Transfer
              </div>
              <div
                className={`travel-mode ${travelType == CityToCity ? "active" : ""
                  }`}
                onClick={() => setTravelType(CityToCity)}
              >
                City Transfer
              </div>
            </Card>
            {travelType == AirportToCity || travelType == CityToAirport ? (
              <AirportTransferComp
                setToggleAddress={setToggleAddress}
                toggleAddress={toggleAddress}
                cityField={cityField}
                airportCityData={airportCityData}
                airportField={airportField}
                handleAirportSelectChange={handleAirportSelectChange}
                handleDestSelectChange={handleDestSelectChange}
                getAddressData={getAddressData}
                handleCustomAirportSelectChange={
                  handleCustomAirportSelectChange
                }
                bookingType={bookingType}
                register={register}
                setValue={setValue}
                watch={watch}
              />
            ) : (
              <CityTransferComp
                handleSourceSelectChange={handleSourceSelectChange}
                handleDestSelectChange={handleDestSelectChange}
                getAddressData={getAddressData}
                register={register}
                setValue={setValue}
                watch={watch}
              />
            )}
            <FormGroup className="row col-lg-12 package-nd-distance">
              <div className="estimated-distance col-3">
                {estimatedData.length > 0 ? (
                  estimatedData[0].estimatedMinKM ? (
                    `${estimatedData[0].estimatedMinKM} Km`
                  ) : (
                    "NA"
                  )
                ) : (
                  <span>
                    <i className="fa fa-ellipsis-h"></i> Km
                  </span>
                )}
              </div>
              <div className="col-9">
                <CustomSelect
                  className="service-select"
                  classNamePrefix="select"
                  isClearable={false}
                  isSearchable={false}
                  value={{
                    label: packageField?.value?.name
                      ? packageField?.value?.name
                      : "Based on Kilometers",
                    value: packageField?.value,
                  }}
                  isDisabled={cityField?.value ? false : true}
                  placeholder="Select Package"
                  options={packagesData}
                  onChange={handlePackageSelectChange}
                />
              </div>
            </FormGroup>

            <Row className="cab-details">
              {carTypeData.length > 0
                ? carTypeData.map((element, index) => {
                  return (
                    <Col key={index} className="col-lg-4">
                      <CabDetails
                        element={element}
                        setCarDetails={setCarDetails}
                        carDetails={carDetails}
                        estimatedData={estimatedData}
                        selectedCoupon={selectedCoupon}
                        setSelectedCoupon={setSelectedCoupon}
                        couponApply={couponApply}
                        editTrip={editTrip}
                      />
                    </Col>
                  );
                })
                : "Select City to select car type"}
            </Row>
            {carTypeData.length > 0 && <Row style={{justifyContent:"center",marginTop: "10px",color:"red"}}>
              *exclusive of toll and MCD
            </Row>}
            <Row>
              <Card className="coupon-payment-card">
              {!hasDiscountedFare && (
                <div
                  className="apply-coupon"
                  style={{ width: selectedCoupon?.couponId ? "40%" : "30%" }}
                >
                  {selectedCoupon?.couponId ? (
                    <div className="applied-coupon-body">
                      <div style={{ width: "20%" }}>
                        <img
                          src={require("../../../assets/images/coupon-img.png")}
                          className="coupon-img"
                        />
                      </div>
                      <div
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          width: "50%",
                        }}
                      >
                        <span style={{ fontSize: 12, fontWeight: 500 }}>
                          {selectedCoupon.code}
                        </span>
                        <span style={{ fontSize: 10, fontWeight: 400 }}>
                          (Applied)
                        </span>
                      </div>
                      <button
                        className="remove-btn"
                        type="button"
                        onClick={() => {
                          setSelectedCoupon({});
                        }}
                      >
                        Remove
                      </button>
                    </div>
                  ) : (
                    <button
                      type="button"
                      className="coupon-btn"
                      disabled={carDetails.length > 0 ? false : true}
                      onClick={() => {
                        setIsCouponOpen(true);
                      }}
                    >
                      <img
                        src={require("../../../assets/images/coupon-img.png")}
                        className="coupon-img"
                      />
                      Apply Coupon
                    </button>
                )}
              </div>
              )}

                  <CouponsModal
                    isOpen={isCouponOpen}
                    title={"Apply Coupon"}
                    toggler={() => setIsCouponOpen(!isCouponOpen)}
                    couponsData={couponsData}
                    setCouponsData={setCouponsData}
                    couponApply={couponApply}
                    carDetails={carDetails}
                    couponSearch={couponSearch}
                  />
              <OfferModal isOpen={isOfferModalOpen} onClose={() => setIsOfferModalOpen(false)} />
                <div
                  className="payment-details"
                  style={{ width: hasDiscountedFare ? "100%" : (selectedCoupon?.couponId ? "58%" : "68%") }}
                >
                  <div
                    className={`payment-mode ${paymentMode == "CreditCustomer" ? "active" : ""
                      }`}
                    onClick={() => setPaymentMode("CreditCustomer")}
                  >
                    <i className="fa fa-credit-card-alt"></i>
                    Credit Customer
                  </div>
                  <div
                    className={`payment-mode ${paymentMode == "Cash" ? "active" : ""
                      }`}
                    onClick={() => setPaymentMode("Cash")}
                  >
                    <i className="fa fa-money"></i>
                    Post Paid
                  </div>
                </div>
              </Card>
            </Row>

            <Row className="submit-booking">
              <button type="submit" className="btn submit-button" disabled={BookStatus}>
                {bookingType == "Edit" ? "Update" : bookingType}
              </button>
            </Row>
          </Row>
        </Row>
      </Form>
    </CommonModal>
  );
};

export default EditBookCab;
